.notes {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
}

.saved {
  margin: 0;
  padding: 8px 10px;
  border: 1px solid var(--accent-line);
  border-radius: var(--radius-chip);
  background: var(--accent-w);
  color: var(--ink);
  font-size: var(--t-dense);
}

.stack {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* The one sentence a role that cannot change the company's shape is told: who can. */
.who {
  margin: 0;
  color: var(--muted);
  font-size: var(--t-dense);
}

.ghost,
.manage {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: var(--h-ctl);
  padding: 0 12px;
  border: 1px solid var(--line-2);
  border-radius: var(--radius-chip);
  background: var(--panel);
  color: var(--ink-2);
  font: inherit;
  font-size: var(--t-dense);
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
}

.manage {
  height: 24px;
  padding: 0 8px;
}

.ghost:hover,
.manage:hover {
  border-color: var(--muted);
  background: var(--panel-2);
  color: var(--ink);
}

.ghost:focus-visible,
.manage:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
}

.indent0 {
  padding-left: 0;
}

.indent1 {
  padding-left: 16px;
}

.indent2 {
  padding-left: 32px;
}

.indent3 {
  padding-left: 48px;
}

.kind {
  color: var(--muted);
}
